import callApi from "../../Api";
import { push } from "react-router-redux";
import { ToastMessage, SUCCESS, ERROR } from "../../common/ToastMessage";
export const SET_FEES = "SET_FEES";
export const OPEN_LOADER = "OPEN_LOADER";
export const CLOSE_LOADER = "CLOSE_LOADER";
export const SET_BRANCH_LIST = "SET_BRANCH_LIST"
export const FEE_STRUCTURE = "FEE_STRUCTURE";
export const BRANCH_STRUCTURE = "BRANCH_STRUCTURE";
export const BRANCH_CLASS_GROUP_STRUCTURE = "BRANCH_CLASS_GROUP_STRUCTURE";
export const SET_CLASS_ROOMS = "SET_CLASS_ROOMS";
export const BRANCH_LEVEL_CLASSGROUPS = "BRANCH_LEVEL_CLASSGROUPS";
export const BRANCH_CLASSGROUP_LEVEL_CLASSROOMS = "BRANCH_CLASSGROUP_LEVEL_CLASSROOMS";

export const RESET_BRANCH_LEVEL_CLASSGROUPS = "RESET_BRANCH_LEVEL_CLASSGROUPS";
export const RESET_BRANCH_CLASSGROUP_LEVEL_CLASSROOMS = "RESET_BRANCH_CLASSGROUP_LEVEL_CLASSROOMS";
export const BRANCH_HIERARCHY = "BRANCH_HIERARCHY"

export const openLoader = (data) => ({
  type: OPEN_LOADER,
  payload: true,
});
export const closeLoader = (data) => ({
  type: CLOSE_LOADER,
  payload: false,
});

export const setFees = (data) => ({
  type: SET_FEES,
  payload: data,
});


export const fetchBranchList = () => async (dispatch) => {
  try {
    dispatch(openLoader());
    const data = await callApi.get("admin/branchesList");
    if (data.data.success) {
      dispatch(closeLoader());
      console.log(data.data.data)
      dispatch({
        type: SET_BRANCH_LIST,
        payload: data.data.data,
      });
    } else {
      ToastMessage(ERROR, data.data.message);
      dispatch(closeLoader());
    }
  } catch (error) {
    console.log("Error message",error)
    ToastMessage(ERROR, error);
    dispatch(closeLoader());
  }
}

export const createBranchName = (payload) => async (dispatch) => {
  try {
    dispatch(openLoader());
    const data = await callApi.post("admin/createBranch",payload);
    if (data.data.success) {
      dispatch(closeLoader());
      ToastMessage(SUCCESS, data.data.message);
    } else {
      ToastMessage(ERROR, data.data.message);
      dispatch(closeLoader());
    }
  } catch (error) {
    console.log("Error message",error)
    ToastMessage(ERROR, error);
    dispatch(closeLoader());
  }
}

export const createClassGroupName = (payload) => async (dispatch) => {
  try {
    dispatch(openLoader());
    const data = await callApi.post("admin/createClassGroupName",payload);
    if (data.data.success) {
      dispatch(closeLoader());
      ToastMessage(SUCCESS, data.data.message);
    } else {
      ToastMessage(ERROR, data.data.message);
      dispatch(closeLoader());
    }
  } catch (error) {
    console.log("Error message",error)
    ToastMessage(ERROR, error);
    dispatch(closeLoader());
  }
}
export const createClassName = (payload) => async (dispatch) => {
  try {
    dispatch(openLoader());
    const data = await callApi.post("admin/createClassName",payload);
    if (data.data.success) {
      dispatch(closeLoader());
      ToastMessage(SUCCESS, data.data.message);
    } else {
      ToastMessage(ERROR, data.data.message);
      dispatch(closeLoader());
    }
  } catch (error) {
    console.log("Error message",error)
    ToastMessage(ERROR, error);
    dispatch(closeLoader());
  }
}

export const fetchBranchClassGroups = (reqObj) => async (dispatch) => {
  try {
    dispatch(openLoader());
    const data = await callApi.get("admin/getBranchClassGroups",{params:reqObj});
    let classGroupData = [];
    if (data.data.success) {
      if(reqObj.BranchId){
        if(reqObj.disabled){
          classGroupData = data.data.data.map(obj=> {
            return { value : obj.id , label : obj.name , disabled: obj.branch_info.length > 0 }
          })
        }else{
          classGroupData = data.data.data.map(obj=> {
            return { value : obj.ClassGroup.id , label : obj.ClassGroup.name , fee: obj.fee , disabled: reqObj.disabled}
          })
        }
        
      }else{
        classGroupData = data.data.data.map(obj=> {
          return { value : obj.id , label : obj.name  , disabled: reqObj.disabled}
        })
      }
      
      dispatch(closeLoader());
      dispatch({
        type: BRANCH_LEVEL_CLASSGROUPS,
        payload: classGroupData,
      });
    } else {
      ToastMessage(ERROR, data.data.message);
      dispatch(closeLoader());
    }
  } catch (error) {
    console.log("Error message",error)
    ToastMessage(ERROR, error);
    dispatch(closeLoader());
  }
};

export const updateClassGroupFeeAction = (reqObj) => async (dispatch) => {
  try {
    dispatch(openLoader());
    const data = await callApi.post("admin/updateGroupFee",reqObj);
    if (data.data.success) {
      dispatch(closeLoader());
      ToastMessage(SUCCESS, data.data.message);
    } else {
      ToastMessage(ERROR, data.data.message);
      dispatch(closeLoader());
    }
  } catch (error) {
    console.log("Error message",error)
    ToastMessage(ERROR, error);
    dispatch(closeLoader());
  }
};

export const branchClassGroupLevelClassRoomsAction = (reqObj) => async (dispatch) => {
  console.log(reqObj)
  try {
    dispatch(openLoader());
    const data = await callApi.get("admin/classGroupRoomList",{params: reqObj});
    if (data.data.success) {
      dispatch(closeLoader());
      let classRoomsData = []
      if(reqObj.BranchId && reqObj.ClassGroupId && reqObj.disabled){
         classRoomsData = data.data.data.map(obj=> {
          return { value : obj.id , label : obj.name , disabled: obj.branch_classgroup_classroom_info.length > 0}
        })
      }else{
         classRoomsData = data.data.data.map(obj=> {
          return { value : obj.id , label : obj.name , disabled: reqObj.disabled}
        })
      }
      
      dispatch({
        type: BRANCH_CLASSGROUP_LEVEL_CLASSROOMS,
        payload: classRoomsData,
      });
      // ToastMessage(SUCCESS, data.data.message);
    } else {
      ToastMessage(ERROR, data.data.message);
      dispatch(closeLoader());
    }
  } catch (error) {
    console.log("Error message",error)
    ToastMessage(ERROR, error);
    dispatch(closeLoader());
  }
};

export const branchClassGroupDetailsAction = (reqObj) => async (dispatch) => {
  try {
    dispatch(openLoader());
    const data = await callApi.get("admin/branchClassGroupRoomList");
    if (data.data.success) {
      dispatch(closeLoader());
      dispatch({
        type: BRANCH_CLASS_GROUP_STRUCTURE,
        payload: data.data.data,
      });
      // ToastMessage(SUCCESS, data.data.message);
    } else {
      ToastMessage(ERROR, data.data.message);
      dispatch(closeLoader());
    }
  } catch (error) {
    console.log("Error message",error)
    ToastMessage(ERROR, error);
    dispatch(closeLoader());
  }
};

export const fetchClassRoomsAction = (reqObj) => async (dispatch) => {
  try {
    dispatch(openLoader());
    const data = await callApi.get("admin/classrooms");
    if (data.data.success) {
      dispatch(closeLoader());
      dispatch({
        type: SET_CLASS_ROOMS,
        payload: data.data.data,
      });
      // ToastMessage(SUCCESS, data.data.message);
    } else {
      ToastMessage(ERROR, data.data.message);
      dispatch(closeLoader());
    }
  } catch (error) {
    console.log("Error message",error)
    ToastMessage(ERROR, error);
    dispatch(closeLoader());
  }
};

export const resetBranchLevelClassGroups = () => async (dispatch)=>{
  
  dispatch({
    type: RESET_BRANCH_LEVEL_CLASSGROUPS,
    payload: [],
  });
}


export const resetBranchClassGroupLevelClassRooms = () => async (dispatch)=>{ 
  dispatch({
    type: RESET_BRANCH_CLASSGROUP_LEVEL_CLASSROOMS,
    payload: [],
  });
}

export const fetchBranchHierarchy = (reqObj) => async (dispatch) => {
  try {
    dispatch(openLoader());
    const data = await callApi.get("admin/branchHierarchy",{params: reqObj});
    if (data.data.success) {
      dispatch(closeLoader());
      console.log(data.data.data)
      dispatch({
        type: BRANCH_HIERARCHY,
        payload: data.data.data,
      });
    } else {
      ToastMessage(ERROR, data.data.message);
      dispatch(closeLoader());
    }
  } catch (error) {
    console.log("Error message",error)
    ToastMessage(ERROR, error);
    dispatch(closeLoader());
  }
}

export const updateClassGroupNameAction = (reqObj) => async (dispatch) => {
  try {
    dispatch(openLoader());
    const data = await callApi.post("admin/updateClassGroupName",reqObj);
    if (data.data.success) {
      dispatch(closeLoader());
      ToastMessage(SUCCESS, data.data.message);
    } else {
      ToastMessage(ERROR, data.data.message);
      dispatch(closeLoader());
    }
  } catch (error) {
    console.log("Error message",error)
    ToastMessage(ERROR, error);
    dispatch(closeLoader());
  }
};
export const updateClassRoomNameAction = (reqObj) => async (dispatch) => {
  try {
    dispatch(openLoader());
    const data = await callApi.post("admin/updateClassRoomName",reqObj);
    if (data.data.success) {
      dispatch(closeLoader());
      ToastMessage(SUCCESS, data.data.message);
    } else {
      ToastMessage(ERROR, data.data.message);
      dispatch(closeLoader());
    }
  } catch (error) {
    console.log("Error message",error)
    ToastMessage(ERROR, error);
    dispatch(closeLoader());
  }
};
